import { Component, forwardRef, Input } from '@angular/core';
import { PlatformApiService } from '../../services/platform-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Account, RoleType} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'cw-ci-account-manage-integration',
  templateUrl: './account-manage-integration.component.html',
  styleUrls: ['./account-manage-integration.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => AccountManageIntegrationComponent)}]
})
export class AccountManageIntegrationComponent extends WizardScreenComponent {
  @Input() account: Account;
  @Input() disableIntegrationCheckbox: boolean;
  isNewIntegration = true;
  originallyEnabled: boolean;
  RoleType = RoleType;

  constructor(private _apiService: PlatformApiService, public sessionService: SessionService) {
    super();
    this.form = new FormGroup ({
      companySite: new FormControl(''),
      companyId: new FormControl(''),
      enableManage: new FormControl(),
      apiPublicKey: new FormControl(''),
      apiPrivateKey: new FormControl(''),
    });
  }

  onLoad() {
    this.showSpinner()
    this.form.reset();
    this._apiService.getAccountIntegration(this.account.id).subscribe(data => {
      if (data) {
        this.isNewIntegration = false;
        this.form.controls.companySite.setValue(data.companySite);
        this.form.controls.companyId.setValue(data.companyId);
        this.form.controls.companySite.disable();
        this.form.controls.companyId.disable();
        this.form.controls.apiPublicKey.setValue(data.apiPublicKey);
        this.form.controls.apiPrivateKey.setValue('**redacted**');
        this.form.controls.enableManage.setValue(data.isEnabled);
        this.originallyEnabled = data.isEnabled;
        this.form.markAsPristine();
      }
      this.hideSpinner();
      super.onLoad();
    }, err => {
      this.hideSpinner();
      super.onLoad();
    });
  }

  onEnableManage() {
    this.notifyWizardComponent('MANAGE_INTEGRATION_CHECKBOX_CLICKED', this.form.controls.enableManage.value);
  }

  onSave() {
    if (this.form.valid) {
      this.showSpinner('Saving...');

      let calculatedDomain = this.form.value.companySite;
      const companyId = this.form.value.companyId;

      if (calculatedDomain) {
        calculatedDomain = calculatedDomain.toLowerCase();
        let domainArray = calculatedDomain.split('://');
        if (domainArray.length > 1) {
          calculatedDomain = domainArray[1];
        }

        domainArray = calculatedDomain.split('/');
        if (domainArray.length > 1) {
          calculatedDomain = domainArray[0];
        }

        if (calculatedDomain.startsWith('api-')) {
          calculatedDomain = calculatedDomain.replace('api-', '');
        }
      } else {

      }

      const integrationObj = {
        isEnabled: this.form.value.enableManage,
        companyId,
        companySite: calculatedDomain,
        apiPublicKey: this.form.value.apiPublicKey,
        apiPrivateKey: undefined
      };

      if (this.form.value.apiPrivateKey != '**redacted**') {
        integrationObj.apiPrivateKey = this.form.value.apiPrivateKey
      }

      this._apiService.saveAccountIntegration(this.account.id, integrationObj).subscribe(resp => {
        this.showMessage('Integration setup has been saved.');
        super.onSave();
        integrationObj.apiPrivateKey = '**redacted**';
        this.notifyWizardComponent('MANAGE_INTEGRATION_SAVED', integrationObj);
        this.onLoad();
      }, err => {
        console.log(err, err.status);
        if (err.status == 401) {
          this.form.controls.apiPublicKey.setErrors({invalid: true});
        } else if (err.status == 403) {
          this.form.controls.apiPublicKey.setErrors({invalidPermissions: true});
        } else if (err.error) {
          if (err.error.code == 'CONNECTWISE_BAD_SITE') {
            this.form.controls.companySite.setErrors({connectionError: true});
          } else if (err.error.code == 'CONNECTWISE_BAD_COMPANYID') {
            this.form.controls.companyId.setErrors({invalid: true});
          } else if (err.error.code == 'INTEGRATION_ALREADY_EXISTS') {
            this.form.controls.companyId.setErrors({alreadyExists: true});
          } else if (err.error.code == 'CONNECTWISE_BAD_API_KEYS') {
            this.form.setErrors({failedAuth: true});
          } else {
            this.showMessage('An error occurred while saving. Please contact an administrator.');
          }
        }
        this.hideSpinner();
      });
    }
  }

  isSaveButtonDisabled() {
    return !(((this.originallyEnabled && !this.disableIntegrationCheckbox && this.isDirty()) ||
      (this.originallyEnabled && this.disableIntegrationCheckbox) ||
      !this.originallyEnabled)
      && this.isValid());
  }
}